import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import * as Highcharts from 'highcharts';
import * as HC_Exporting from 'highcharts/modules/exporting';
// (HC_Exporting as any)(Highcharts);

import * as Boost from 'highcharts/modules/boost';
import * as NoData from 'highcharts/modules/no-data-to-display';
import * as More from 'highcharts/highcharts-more';
import * as Threed from 'highcharts/highcharts-3d';
import * as SeriesLabel from 'highcharts/modules/series-label';
// (Boost as any)(Highcharts);
// (More as any)(Highcharts);
// (NoData as any)(Highcharts);
// (Threed as any)(Highcharts);
// (SeriesLabel as any)(Highcharts);

@Component({
  selector: 'vl-chart',
  templateUrl: './high-chart.component.html',
  styleUrls: ['./high-chart.component.scss']
})
export class HighChartComponent implements OnInit {

  Highcharts: typeof Highcharts = Highcharts;
  @Input() chartOptions: Highcharts.Options | undefined;
  @Input() height: any;
  dataPresent = false;
  updateChart = false;

  constructor() { }

  ngOnInit() {
    Highcharts.setOptions({
      lang: {
        thousandsSep: ','
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.chartOptions = changes['chartOptions'].currentValue;
    if (this.chartOptions && Object.keys(this.chartOptions).length > 0) {
      this.dataPresent = true;
      this.updateChart = true;
    }
  }

}
